interface Props {
  children: React.ReactNode;
  colorSwap?: boolean;
  header: number | string;
}

export default function MonsterInfoCard({ children, colorSwap, header }: Props) {
  if (colorSwap) {
    return (
      <div className='divide-monsterPurple/65 bg-siteBackground divide-y overflow-hidden rounded-lg text-white shadow-sm'>
        <div className='px-4 py-5 text-2xl font-bold sm:px-6'>{header}</div>
        <div className='px-4 py-5 sm:p-6'>{children}</div>
      </div>
    );
  }

  return (
    <div className='divide-monsterPurple/65 bg-siteBackgroundLighter text-siteBackground divide-y overflow-hidden rounded-lg shadow-sm'>
      <div className='px-4 py-5 text-2xl font-bold sm:px-6'>{header}</div>
      <div className='px-4 py-5 sm:p-6'>{children}</div>
    </div>
  );
}
